const presetContext = require.context('../presets', false, /\.txt$/);

const presetFiles = presetContext.keys().reduce((acc, key) => {
  const fileName = key.replace('./', '');
  acc[fileName] = presetContext(key);
  return acc;
}, {});

const presetSlugs = Object.keys(presetFiles).map(fileName => fileName.replace(/\.txt$/i, ''));
const presetSlugLookup = presetSlugs.reduce((acc, slug) => {
  acc[slug.toLowerCase()] = slug;
  return acc;
}, {});

export const presetFileNames = Object.keys(presetFiles);

export const getPresetSlugFromPath = (pathname) => {
  if (!pathname) return null;
  const cleaned = pathname.replace(/^\/+|\/+$/g, '');
  if (!cleaned) return null;
  const candidate = cleaned.split('/')[0];
  return presetSlugLookup[candidate.toLowerCase()] || null;
};

export const getPresetUrlBySlug = (slug) => {
  if (!slug) return null;
  const normalized = presetSlugLookup[slug.toLowerCase()] || slug;
  return presetFiles[`${normalized}.txt`] || null;
};

export const getPresetTitleFromSlug = (slug) => {
  if (!slug) return '';
  const normalized = slug.replace(/[-_]+/g, ' ').trim();
  return normalized.replace(/\b\w/g, (char) => char.toUpperCase());
};

/** Display names for example lists (sidebar, logged-out). Slug -> name. */
export const EXAMPLE_LISTS = {
  'default': 'Features',
  'moving-relocation-checklist': 'Moving checklist',
  'travel-checklist': 'Travel checklist',
  'weekly': 'Weekly',
};

/** Display name for a preset: custom name from EXAMPLE_LISTS or title from slug. */
export const getPresetDisplayName = (slug) => {
  if (!slug) return '';
  const normalized = presetSlugLookup[slug.toLowerCase()] || slug;
  return EXAMPLE_LISTS[normalized] || getPresetTitleFromSlug(slug);
};

/** List of { slug, name } for example lists (only presets in EXAMPLE_LISTS). */
export const getExampleLists = () =>
  Object.entries(EXAMPLE_LISTS).map(([slug, name]) => ({ slug, name }));
